import React from "react";

const Anchor = () => (
  <svg
    className="anchor-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 68.98 69.42"
  >
    <title>Asset 1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g className="cls-1" id="Layer_1-2" data-name="Layer 1">
        <path d="M68.6,35.62l-7.4-7.4a1.93,1.93,0,0,0-2.8,0h0l-7.5,7.4a2,2,0,0,0,2.8,2.8h0l4-4v7.8a23.09,23.09,0,0,1-21.2,23V18.82a9.51,9.51,0,1,0-4,0v46.5a23.25,23.25,0,0,1-21.2-23.1v-7.8l4,4a2,2,0,1,0,3.1-2.5l-.3-.3-7.4-7.4c-.1-.1-.2-.2-.3-.2h-.1a.37.37,0,0,0-.3-.1H9.9l-.1-.3a1.1,1.1,0,0,0-.8,0l-.2.1H8.7c-.1,0-.2.1-.3.1H8.3c-.1.1-.2.2-.3.2L.6,35.62a1.93,1.93,0,0,0,0,2.8,1.93,1.93,0,0,0,2.8,0h0l4-4v7.8a27.2,27.2,0,1,0,54.4,0v-7.8l4,4a2,2,0,0,0,2.8-.4A2.11,2.11,0,0,0,68.6,35.62ZM29.1,9.42a5.55,5.55,0,1,1,11.1.1,5.55,5.55,0,1,1-11.1-.1Z" />
      </g>
    </g>
  </svg>
);

export default Anchor;
